import { BREAKPOINT } from '@/constants/enum';
import { InlineGrid } from '@shopify/polaris';
import { memo } from 'react';
import { useMediaQuery } from 'react-responsive';

interface Props {
  children: any;
  isHiddenPreview?: boolean;
}
const GridLayoutPreview = ({ children, isHiddenPreview }: Props) => {
  const isMobile = useMediaQuery({ maxWidth: BREAKPOINT.SM });

  return (
    <InlineGrid columns={isMobile || isHiddenPreview ? 1 : ['twoThirds', 'oneThird']} gap={'400'}>
      {children}
    </InlineGrid>
  );
};

export default memo(GridLayoutPreview);
